import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Card, CardContent, CardMedia } from '@one-thd/sui-atomic-components';

export const CardProject = ({ project, city }) => {
  const { title, imageURL, url, totalJobs } = project;

  if (!title || !imageURL || !url || !totalJobs) return null;

  return (
    <a href={url} className="sui-grid">
      <Card
        disablePadding
        disableGutters
        grow
        orientation="horizontal"
      >
        <CardContent
          disablePadding
          disableGutters
          grow
        >
          <div className="sui-flex sui-h-full sui-grow">
            <CardMedia
              component={() => (
                <img
                  className="sui-object-cover sui-w-32 sui-min-h-32 sui-h-full"
                  src={`${imageURL}?w=140&q=80`}
                  alt="Project"
                  width="140"
                  height="140"
                />
              )}
            />
            <div className="sui-flex sui-flex-col sui-gap-2 sui-p-4 sui-grow">
              <Typography variant="body-lg" weight="bold">{title}</Typography>
              <Typography variant="body-base" color="subtle">{totalJobs} completed in {city}</Typography>
            </div>
          </div>
        </CardContent>
      </Card>
    </a>
  );
};

CardProject.propTypes = {
  project: PropTypes.shape({
    title: PropTypes.string,
    imageURL: PropTypes.string,
    url: PropTypes.string,
    totalJobs: PropTypes.number
  }).isRequired,
  city: PropTypes.string.isRequired
};